namespace Matrix.Workflow {
    export namespace WorkflowMapService {
        export const baseUrl = 'Workflow/WorkflowMap';

        export declare function Create(request: Serenity.SaveRequest<WorkflowMapRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<WorkflowMapRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<WorkflowMapRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WorkflowMapRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function BatchAssignment(request: WorkflowMapBatchAssignmentRequest, onSuccess?: (response: WorkflowMapBatchAssignmentResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function BatchUpdate(request: WorkflowMapBatchUpdateRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function BatchDelete(request: WorkflowMapBatchDeleteRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Workflow/WorkflowMap/Create",
            Update = "Workflow/WorkflowMap/Update",
            Delete = "Workflow/WorkflowMap/Delete",
            Retrieve = "Workflow/WorkflowMap/Retrieve",
            List = "Workflow/WorkflowMap/List",
            BatchAssignment = "Workflow/WorkflowMap/BatchAssignment",
            BatchUpdate = "Workflow/WorkflowMap/BatchUpdate",
            BatchDelete = "Workflow/WorkflowMap/BatchDelete"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'BatchAssignment', 
            'BatchUpdate', 
            'BatchDelete'
        ].forEach(x => {
            (<any>WorkflowMapService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
